module.exports = __webpack_public_path__ + "img/icbc.0884efe1.png";